import {Component, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CookieOptions, CookieService} from 'ngx-cookie';
import {AppState} from '../../../app.state';
import {LocaleService} from '../../global/locale.service';
import {FM_LANG} from '../../global/cookies.constants';
import {SUPPORTED_LANGUAGES} from '../../global/supported-languages';

@Component({
  selector: 'app-language-select',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./language-select.component.scss'],
  templateUrl: './language-select.component.html'
})
export class LanguageSelectComponent {

  public supportedLanguages = SUPPORTED_LANGUAGES;
  public languageIcon: string;
  public isMenuCollapsed = false;

  constructor(private _state: AppState,
              private _translate: TranslateService,
              private cookieService: CookieService,
              private localeService: LocaleService) {

    this.languageIcon = this.getFlag();
    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });
  }

  private getFlag(): string {
    return this.supportedLanguages
      .find(lang => lang.value === this._translate.currentLang).flag;
  }

  public selectLang(lang: any) {
    this._translate.use(lang.value);
    this.localeService.loadLocale(lang.value);
    let exp = new Date(2040, 12, 21);
    let cookieOptions = {expires: exp} as CookieOptions;
    this.cookieService.put(FM_LANG, lang.value, cookieOptions);
    this._state.notifyDataChanged('lang.changed', lang.value);
    this.languageIcon = lang.flag;
  }

  public showLanguages() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
  }
}
